import { createAction } from 'redux-starter-kit';
import { requestStart, requestFailed, requestSucceded } from '../../../domain/requests/RequestActions';
import {get, post, remove} from '../../../../utility/via-fetch';
import {
  putVehicles,
  putVehicle,
  putVehicleDamages,
  putVehiclesPostDamages,
  putVehicleRetirement,
  putVehicleUsage,
  putVehicleReinstated,
  deleteVehicle, putVehicleSavedUsage,
} from '../../../domain/vehicles/vehicleActions';
import { putModelTypes } from '../../../domain/modelTypes/modelTypeActions';
import { putVehicleDiagrams } from '../../../domain/vehicleDiagrams/vehicleDiagramActions';
import { addMessage } from '../../application/messageUiActions';


/**
 * An action that signifies a vehicle is being currently edited.
 * @example dispatch(editVehicle(vehicleId))
 */
export const editVehicle = createAction('EDIT_VEHICLE');

/**
 * An action that signifies a vehicle is being currently edited.
 * @example dispatch(editVehicle(vehicleId))
 */
export const editVehicleDamage = createAction('EDIT_VEHICLE_DAMAGE');

/**
 * An action that signifies no vehicle is being edited.
 * @example dispatch(cancelEditVehicle())
 */
export const cancelEditVehicle = createAction('CANCEL_EDIT_VEHICLE');

/**
 * An action that signifies no vehicle is being edited.
 * @example dispatch(cancelEditVehicleDamage())
 */
export const cancelEditVehicleDamage = createAction('CANCEL_EDIT_VEHICLE_DAMAGE');

/**
 * An action that signifies a vehicle is being retired.
 * @example dispatch(retireVehicle())
 */
export const retireVehicle = createAction('RETIRE_VEHICLE');

/**
 * An action that signifies a vehicle is being reinstated.
 * @example dispatch(reinstateVehicle())
 */
export const reinstateVehicle = createAction('REINSTATE_VEHICLE');

/**
 * An action that signifies a vehicle is being retired.
 * @example dispatch(retireVehicle())
 */
export const cancelRetireVehicle = createAction('CANCEL_RETIRE_VEHICLE');

/**
 * An action that signifies a vehicle is being retired.
 * @example dispatch(retireVehicle())
 */
export const cancelReinstateVehicle = createAction('CANCEL_REINSTATE_VEHICLE');

/**
 * An action that signifies a fetch request to load vehicles has been made.
 * @example dispatch(fetchVehicles(requestId))
 */
export const fetchVehicles = createAction('FETCH_VEHICLES');

/**
 * An action that signifies that a fetch to add a vehicle has been
 * made in the Vehicle Management screen. This should pass through the request id.
 * @example dispatch(fetchAddVehicle(requestId))
 */
export const fetchAddVehicle = createAction('FETCH_CREATE_VEHICLE');

/**
 * An action that signifies that a fetch to update a vehicle Item
 * has been made in the Vehicle Configuration screen. This should pass through the request id.
 * @example dispatch(fetchUpdateVehicle(requestId));
 */
export const fetchUpdateVehicle = createAction('FETCH_UPDATE_VEHICLE');

/**
 * An action that signifies that a fetch to update a vehicle Item
 * has been made in the Vehicle Configuration screen. This should pass through the request id.
 * @example dispatch(fetchUpdateVehicleDamages(requestId));
 */
export const fetchUpdateVehicleDamages = createAction('FETCH_UPDATE_VEHICLE_DAMAGES');

/**
 * An action that signifies that a fetch to retire a vehicle
 * has been made in the Vehicle Configuration screen. This should pass through the request id.
 * @example dispatch(fetchRetireVehicle(requestId));
 */
export const fetchRetireVehicle = createAction('FETCH_RETIRE_VEHICLE');

/**
 * An action that signifies that a fetch to reinstate a vehicle
 * has been made in the Vehicle Configuration screen. This should pass through the request id.
 * @example dispatch(fetchRetireVehicle(requestId));
 */
export const fetchReinstateVehicle = createAction('FETCH_REINSTATE_VEHICLE');

/**
 * An action that signifies a request to load vehicle data has been made.
 */
export const fetchVehicleDetailsPageData = createAction('FETCH_VEHICLE_DETAILS_PAGE_DATA');


/**
 * An action that signifies that a fetch for a vehicle's usage information
 * has been made in the Vehicle Configuration screen. This should pass through the request id.
 * @example dispatch(fetchRetireVehicle(requestId));
 */
export const fetchVehicleUsage = createAction('FETCH_VEHICLE_USAGE');

/**
 * An action that signifies that a fetch to delete a vehicle Item
 * has been made in the Vehicle Configuration screen. This should pass through the request id.
 * @example dispatch(fetchDeleteVehicle(requestId));
 */
export const fetchDeleteVehicle = createAction('FETCH_DELETE_VEHICLE');

/**
 * An action that signifies a request for the Model Types has been made.
 * This takes a request id as an argument.
 * @example dispatch(fetchModelTypes(requestId))
 */
export const fetchModelTypes = createAction('FETCH_MODEL_TYPES');

/**
 * An action that signifies a request for the Vehicle Diagrams has been made.
 * This takes a request id as an argument.
 * @example dispatch(fetchVehicleDiagrams(requestId))
 */
export const fetchVehicleDiagrams = createAction('FETCH_VEHICLE_DIAGRAMS');

/**
 * An action that signifies a request for the Vehicle Diagrams has been made.
 * This takes a request id as an argument.
 * @example dispatch(fetchVehicleDiagrams(requestId))
 */
export const fetchVehicleDamages = createAction('FETCH_VEHICLE_DAMAGES');



export function requestVehicles() {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchVehicles.toString()));
    dispatch(fetchVehicles(requestId));
    try {
      const vehicles = await get('/api/vehicles/');

      // Normalise data. Store the data in the domain, and the ids in the vehicle response.
      dispatch(putVehicles(vehicles));
      dispatch(requestSucceded(requestId, vehicles.map(vehicle => vehicle.regNumber)));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

/**
 * An action for loading model types in the Vehicle Configuration screen.
 * @example dispatch(requestModelTypes())
 */
export const requestModelTypes = () => async (dispatch) => {
  const requestId = dispatch(requestStart(fetchModelTypes.toString()));
  dispatch(fetchModelTypes(requestId));

  try {
    const modelTypes = await get('/api/model-types');
    dispatch(putModelTypes(modelTypes));
    dispatch(requestSucceded(requestId));
  } catch (error) {
    dispatch(requestFailed(requestId, error));
  }
};

/**
 * An action for loading vehicle diagrams in the Vehicle Configuration screen.
 * @example dispatch(requestVehicleDiagrams())
 */
export const requestVehicleDiagrams = () => async (dispatch) => {
  const requestId = dispatch(requestStart(fetchVehicleDiagrams.toString()));
  dispatch(fetchVehicleDiagrams(requestId));

  try {
    const vehicleDiagrams = await get('/api/configuration/vehicle-diagrams');
    dispatch(putVehicleDiagrams(vehicleDiagrams));
    dispatch(requestSucceded(requestId));
  } catch (error) {
    dispatch(requestFailed(requestId, error));
  }
};

/**
 * An action for creating a vehicle on the server.
 * @param {object} vehicle A vehicle to be created.
 * @example dispatch(requestAddVehicle(type));
 */
export function requestAddVehicle(vehicle) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchAddVehicle.toString()));
    dispatch(fetchAddVehicle(requestId));
    try {
      // Construct our new type object
      const createdVehicle = {
        ...vehicle,
      };

      // Create a new vehicle
      createdVehicle.vehicleId = await post('/api/vehicles', {}, vehicle);
      dispatch(putVehicle(createdVehicle));
      dispatch(cancelEditVehicle());
      dispatch(requestSucceded(requestId, createdVehicle.vehicleId));
      dispatch(addMessage('success', 'itemSaved', { item: createdVehicle.regNumber }));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

export function requestUpdateVehicle(vehicle) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchUpdateVehicle.toString()));
    dispatch(fetchUpdateVehicle(requestId));
    try {
      const updatedVehicle = {
        ...vehicle,
      };

      await post(`/api/vehicles/${vehicle.vehicleId}`, {}, updatedVehicle);
      dispatch(putVehicle(updatedVehicle));
      dispatch(cancelEditVehicle());
      dispatch(requestSucceded(requestId, updatedVehicle.vehicleId));
      dispatch(addMessage('success', 'itemUpdated', { item: updatedVehicle.regNumber }));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

export function requestVehicleDetailsPageData() {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchVehicleDetailsPageData.toString()));
    dispatch(fetchVehicleDetailsPageData(requestId));
    try {
      const [vehicles, modelTypes, vehicleDiagrams] = await Promise.all([get('/api/vehicles/list/'), get('/api/model-types'), get('/api/configuration/vehicle-diagrams')]);

      // Normalise data. Store the data in the domain, and the ids in the vehicle response.
      dispatch(putVehicles(vehicles));
      dispatch(putModelTypes(modelTypes));
      dispatch(putVehicleDiagrams(vehicleDiagrams));
      dispatch(requestSucceded(requestId, vehicles.map(vehicle => vehicle.regNumber)));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

export function requestAllVehicleDetails() {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchVehicleDetailsPageData.toString()));
    dispatch(fetchVehicleDetailsPageData(requestId));
    try {
      const vehicles = await get('/api/vehicles/list/');
      // Normalise data. Store the data in the domain, and the ids in the vehicle response.
      dispatch(putVehicles(vehicles));
      dispatch(requestSucceded(requestId, vehicles.map(vehicle => vehicle.regNumber)));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

export const requestVehicleDamages = vehicleId => async (dispatch) => {
  const requestId = dispatch(requestStart(fetchVehicleDamages.toString()));
  dispatch(fetchVehicleDamages(requestId));

  try {
    const vehicleDamages = await get(`/api/vehicles/${vehicleId}`);

    dispatch(putVehicleDamages(vehicleDamages));
    dispatch(requestSucceded(requestId));
  } catch (error) {
    dispatch(requestFailed(requestId, error));
  }
};

export function requestUpdateVehicleDamages(vehicle, repairedItemIds) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart());
    dispatch(fetchUpdateVehicleDamages(requestId));
    try {
      const updatedVeh = await post(`/api/vehicles/${vehicle.vehicleId}/repair-damage/`, {}, repairedItemIds);

      dispatch(cancelEditVehicleDamage());
      dispatch(putVehiclesPostDamages(updatedVeh));
      dispatch(requestSucceded(requestId, vehicle.regNumber));
      dispatch(addMessage('success', 'itemUpdated', { item: vehicle.regNumber }));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

/**
 * Retires the vehicle from the active fleet
 * @param {Integer} vehicleId The id of the vehicle to be defleeted.
 */
export function requestRetireVehicle(vehicleId, regNumber, dateExpression, userId, userName) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart());
    dispatch(fetchRetireVehicle(requestId));
    try {
      await post(`/api/vehicles/${vehicleId}/retire/${dateExpression}`);

      dispatch(cancelRetireVehicle());
      dispatch(putVehicleRetirement([vehicleId, userId, userName]));
      dispatch(requestSucceded(requestId, regNumber));
      dispatch(addMessage('success', 'itemUpdated', { item: regNumber }));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}
/**
 * Reinstates the vehicle to the active fleet
 * @param {Integer} vehicleId The id of the vehicle to be refleeted.
 */
export function requestReinstateVehicle(vehicleId, regNumber) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart());
    dispatch(fetchReinstateVehicle(requestId));
    try {
      await post(`/api/vehicles/${vehicleId}/reinstate/`);

      dispatch(cancelReinstateVehicle());
      dispatch(putVehicleReinstated(vehicleId));
      dispatch(requestSucceded(requestId, regNumber));
      dispatch(addMessage('success', 'itemUpdated', { item: regNumber }));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}
export function requestVehicleSavedUsage(vehicleId) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart());
    dispatch(fetchVehicleUsage(requestId));
    try {
      const result = await get(`/api/vehicles/${vehicleId}/has-saved-inspection/`);
      dispatch(putVehicleSavedUsage([vehicleId, result]));
      dispatch(requestSucceded(requestId, vehicleId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}
export function requestVehicleAllUsage(vehicleId) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart());
    dispatch(fetchVehicleUsage(requestId));
    try {
      const result = await get(`/api/vehicles/${vehicleId}/has-any-inspection/`);
      dispatch(putVehicleUsage([vehicleId, result]));
      dispatch(requestSucceded(requestId, vehicleId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

export function requestDeleteVehicle(vehicleId, regNo) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchDeleteVehicle().toString()));
    dispatch(fetchDeleteVehicle(requestId));
    try {
      await remove(`/api/vehicles/${vehicleId}`, {});
      dispatch(cancelEditVehicle());
      dispatch(deleteVehicle(vehicleId));
      dispatch(requestSucceded(requestId, vehicleId));
      dispatch(addMessage('success', 'itemDeleted', { item: regNo }));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}
